module.exports = new __parcel__URL__("apply_c_faq_closed_btn_zh-tw.0652da53.webp").toString();